export const PORTAL_KEY = process.env.REACT_APP_PORTAL_KEY || 'compliance_app';

export const EMPLOYEE_LOGIN_URL =
  process.env.REACT_APP_EMPLOYEE_LOGIN_URL || 'https://employee.countrylion.co.uk/login';

export const EMPLOYEE_HOME_URL =
  process.env.REACT_APP_EMPLOYEE_HOME_URL || 'https://employee.countrylion.co.uk/dashboard';

export const EMPLOYEE_LOGOUT_URL =
  process.env.REACT_APP_EMPLOYEE_LOGOUT_URL ||
  'https://employee.countrylion.co.uk/api/logoutPortalUser';

export function getEmployeeLoginRedirectUrl() {
  return `${EMPLOYEE_LOGIN_URL}?app=${PORTAL_KEY}`;
}

export async function fetchPortalSession() {
  const response = await fetch('/api/session', {
    method: 'GET',
    credentials: 'include',
  });

  if (response.status === 401 || response.status === 403) {
    return { ok: false, status: response.status, user: null };
  }

  if (!response.ok) {
    throw new Error('Could not verify Country Lion session.');
  }

  const data = await response.json();
  return { ok: true, status: 200, user: data.user || null, role: data.role || null };
}

export async function logoutPortalSession() {
  try {
    await fetch(EMPLOYEE_LOGOUT_URL, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: '{}',
    });
  } catch {
    // Local logout should still succeed if the central logout call fails.
  }
}

export function getMappedComplianceInitials(masterUser) {
  const mapped = masterUser?.portalMappings?.compliance_app?.profileId;
  return typeof mapped === 'string' ? mapped.trim().toUpperCase() : '';
}
